import React from 'react'
import "./Companies.css"
const Companies = () => {
  return (
    <section className="c-wrapper">

        <div className="paddings innerWidth flexCenter c-container">

            <img src="w1.jpg" alt="" />
            <img src="w2.jpg" alt="" />
            <img src="w3.jpg" alt="" />
            <img src="w4.jpg" alt="" />
        </div>
    </section>
  )
}

export default Companies
